const CHAT_IMAGE_PATH = /^\/uploads\/online\/(?:admin|chat)-[a-f0-9]{32}\.(?:png|jpe?g|webp)$/i;

export function resolveChatImageUrl(value) {
  const source = String(value || '').trim();
  if (!source) return '';

  if (CHAT_IMAGE_PATH.test(source)) return source;

  const normalized = source.startsWith('uploads/online/') ? `/${source}` : source;
  if (CHAT_IMAGE_PATH.test(normalized)) return normalized;

  if (!/^https?:\/\//i.test(source)) return '';
  try {
    const url = new URL(source);
    return CHAT_IMAGE_PATH.test(url.pathname) ? source : '';
  } catch (_) {
    return '';
  }
}

